/* eslint-disable react-hooks/exhaustive-deps */
import BaseLayout from "../Layout/BaseLayout";
//nextui
import {
  Button,
  Card,
  Divider,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Spinner,
  Textarea,
  useDisclosure,
} from "@nextui-org/react";
// react-i18next
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useApi } from "../Context/ApiProvider";
import toast, { Toaster } from "react-hot-toast";
import { StarIcon } from "@heroicons/react/24/outline";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Helmet } from "react-helmet";
import ImageBackground from "../Components/ImageBackground";

const isValidEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

const StarRating = ({ rating, onRatingChange }) => {
  const [hoveredRating, setHoveredRating] = useState(0);

  const handleMouseEnter = (index) => {
    setHoveredRating(index);
  };

  const handleMouseLeave = () => {
    setHoveredRating(0);
  };

  const handleClick = (index) => {
    onRatingChange(index); // Update the rating based on click
  };

  return (
    <div className="flex items-center ">
      {Array.from({ length: 5 }, (_, index) => (
        <StarIcon
          key={index}
          className={`h-6 w-6 ${
            index < (hoveredRating || rating)
              ? "text-yellow-500"
              : "text-gray-400"
          } hover:cursor-pointer`} // Change color based on hover or selected rating
          onMouseEnter={() => handleMouseEnter(index + 1)}
          onMouseLeave={handleMouseLeave}
          onClick={() => handleClick(index + 1)}
        />
      ))}
    </div>
  );
};

export const HeartIcon = ({
  fill = "currentColor",
  filled,
  size,
  height,
  width,
  label,
  ...props
}) => {
  return (
    <svg
      width={size || width || 24}
      height={size || height || 24}
      viewBox="0 0 24 24"
      fill={filled ? fill : "none"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.62 20.81c-.34.12-.9.12-1.24 0C8.48 19.82 2 15.69 2 8.69 2 5.6 4.49 3.1 7.56 3.1c1.82 0 3.43.88 4.44 2.24a5.53 5.53 0 0 1 4.44-2.24C19.51 3.1 22 5.6 22 8.69c0 7-6.48 11.13-9.38 12.12Z"
        stroke={fill}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export function ImageProvider({ images, showGallery = true, className }) {
  const [mainImage, setMainImage] = useState(
    images.length > 0 && images[0]?.image?.url
      ? images[0].image.url
      : "/Assets/Images/images.png"
  );

  const changeImage = (currentImage) => {
    setMainImage(currentImage || "/Assets/Images/images.png");
  };
  return (
    <div className={`flex flex-col md:w-1/2  ${className}`}>
      {mainImage && (
        <ImageBackground className={"!w-full md:!h-[50vh] !rounded-lg"}>
          <img
            src={mainImage}
            alt="Product"
            className=" lg:w-full  object-contain rounded-lg h-auto "
            id="mainImage"
          />
        </ImageBackground>
      )}
      {showGallery && (
        <div className="flex gap-2 py-4  w-full  !items-center overflow-x-auto mt-5 ">
          {images.map((imageItem, index) => (
            <ImageBackground
              className={"!h-full min-w-28 !p-0 !border !border-gray-300"}
            >
              <img
                key={imageItem.id || index}
                src={imageItem.image.url}
                alt={`Thumbnail ${imageItem.id}`}
                className=" h-20 p-2  rounded-lg cursor-pointer opacity-60 hover:opacity-100 transition duration-300"
                onClick={() => changeImage(imageItem.image.url)}
              />
            </ImageBackground>
          ))}
        </div>
      )}
    </div>
  );
}

export default function SingleProductPage() {
  const { t } = useTranslation();
  const api = useApi();
  const navigate = useNavigate();
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [images, setImages] = useState([]);

  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [reviewMessage, setReviewMessage] = useState("");
  const [reviews, setReviews] = useState();
  const [rating, setRating] = useState(0);
  const [emailError] = useState("");
  const [seoData, setSeoData] = useState({
    seo_title: "",
    search_description: "",
  });

  const lastNameRef = useRef();
  const EmailRef = useRef();

  useEffect(() => {
    const getData = async () => {
      const res = await api.get("/api/comments?page=" + id);
      if (res.ok && res.body) {
        setReviews(res.body.results);
      } else {
        console.error("Failed to fetch reviews data:", res);
      }
    };
    getData();
  }, [api]);

  useEffect(() => {
    (async () => {
      const resProduct = await api.uget(`/api/shop/products/${id}?`);
      if (resProduct.ok && resProduct.body) {
        const fetchedProduct = resProduct.body;
        setProduct(fetchedProduct);
        setImages(fetchedProduct.gallery);
        setSeoData({
          seo_title: fetchedProduct.seo_title,
          search_description: fetchedProduct.search_description,
        });
      }
    })();
  }, [id, api]);

  const setUserView = async (page, name, email, message, rating) => {
    const res = await api.post("/api/comments", {
      page,
      name,
      email,
      message,
      rating,
    });
    if (res.status === 201) {
      toast.success("نظر شما با موفقیت ثبت شد");
      setReviewMessage("");
      setRating(0);
      onOpenChange();
    }
  };

  const handleSubmit = () => {
    const name = lastNameRef.current.value;
    const email = EmailRef.current.value;

    // Validate email format
    if (!isValidEmail(email)) {
      toast.error("لطفاً یک ایمیل معتبر وارد کنید.");
      return; // Stop the submission process if the email is invalid
    }

    setUserView(id, name, email, reviewMessage, rating);
  };

  if (!product) {
    return (
      <Spinner size="lg" className="flex justify-center mt-80 !bg-white " />
    );
  }

  return (
    <>
      <Toaster />
      <BaseLayout>
        <Helmet>
          <title>{seoData.seo_title}</title>
          <meta name="description" content={seoData.search_description} />
        </Helmet>
        <Swiper
          dir="rtl"
          className="h-[25rem]  lg:h-[35rem]  xl:h-[40rem]  bg-primary-800 bg-opacity-80 mt-10 lg:mt-0"
          loop={true}
          navigation={true}
          modules={[Navigation]}
        >
          <SwiperSlide key={1}>
            <div className="text-white space-y-5  absolute top-[50%] lg:top-[55%]  left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 space-x-4 flex flex-col lg:gap-3 items-center justify-center">
              <ImageBackground
                className={"!w-[50%] !h-[20vh]  !p-0 md:!h-[30vh] !rounded-lg"}
              >
                <ImageProvider
                  images={images}
                  showGallery={false}
                  className={" !w-full !h-full !object-none"}
                />
              </ImageBackground>
              <div className="leading-loose  ">
                <h1 className=" lg:text-xl xl:text-2xl font-bold whitespace-nowrap text-center">
                  {product.title}
                </h1>
                <Divider className="bg-red-600 h-1  my-2" />
                <div
                  className={`bg-white px-5 py-2 rounded-md   flex justify-center items-center w-full whitespace-nowrap ${
                    localStorage.getItem("lng") === "fa"
                      ? "rtl"
                      : localStorage.getItem("lng") === "en"
                      ? "ltr flex-row-reverse lg:flex-row"
                      : ""
                  }`}
                >
                  <div
                    className="text-sm text-gray-600 cursor-pointer"
                    onClick={() => navigate("/")}
                  >
                    {t("menuHome")}
                  </div>
                  <span className="px-2 text-black">/</span>
                  <div>
                    <span
                      className="text-sm text-gray-600 cursor-pointer "
                      onClick={() => navigate("/products")}
                    >
                      {t("categortlisttitle")}
                    </span>
                  </div>
                  <span className="px-2 text-black">/</span>
                  <div>
                    <span className="text-[15px] text-black font-bold ">
                      {t("ProductDetail")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>

        <div
          className={`flex flex-col lg:flex-row    ${
            localStorage.getItem("lng") === "en" ? "" : ""
          }  items-center  `}
        >
          <div className="w-[85%] lg:w-[70%] xl:w-[60%] 2xl:w-[60%] m-auto mt-16 ">
            <div className=" rounded-xl  ">
              <div className="md:flex md:gap-7 2xl:gap-0  justify-evenly  ">
                <ImageProvider images={images} />
                <div className="whitespace-nowrap">
                  <span>
                    <h2 className="md:text-3xl font-bold mt-3 mb-1 xl:mt-7">
                      {product.title}
                    </h2>
                    <p className="text-gray-700 mb-4">{product.excerpt}</p>
                  </span>

                  <div
                    className=" text-gray-900  leading-loose  "
                    dangerouslySetInnerHTML={{ __html: product.body }}
                  />

                  <div className="flex space-x-4 mt-5 mb-5  items-center">
                    <Button
                      radius="sm"
                      className="bg-gray-800 text-white text-xl"
                    >
                      <div className="flex flex-row items-center justify-center gap-2">
                        <HeartIcon /> <span className="pt-1">Like</span>
                      </div>
                    </Button>
                  </div>
                </div>
              </div>

              <Card className="p-8 mb-10 mt-10 ">
                <div className="flex flex-col  lg:flex-row mb-6 items-center justify-between">
                  <h2 className="text-3xl font-MorabbaMeduim text-mainColor mb-4">
                    {t("usersReviews")}
                  </h2>
                  <Button
                    onPress={onOpen}
                    color="primary"
                    className="text-white text-xl"
                  >
                    <span>{t("AddReview")}</span>
                  </Button>
                </div>
                <Divider className="bg-primary mb-7 " />
                {reviews && reviews.length > 0
                  ? reviews.map((review) => (
                      <div
                        key={review.id}
                        className="flex bg-gray-200 dark:bg-zinc-800 rounded-lg p-4 mb-4 "
                      >
                        <div className="flex-1  ">
                          <div className="flex justify-between items-center">
                            <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                              {review.name ? review.name : "کاربر سایت"}
                            </h3>

                            <span className="text-sm text-gray-500 dark:text-gray-400">
                              {new Date(review.created_at).toLocaleDateString(
                                "fa-IR"
                              )}{" "}
                              {/* Format the date as per your need */}
                            </span>
                          </div>
                          <div className="flex items-center justify-end ">
                            <p className="text-gray-600 dark:text-gray-200 mt-2  w-full">
                              {review.message}
                            </p>
                            <div>
                              <div className="flex">
                                {Array.from(
                                  { length: review.rating },
                                  (_, index) => (
                                    <StarIcon
                                      key={index}
                                      className="h-5 w-5   text-yellow-500"
                                    />
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  : null}

                <Modal
                  isOpen={isOpen}
                  onOpenChange={onOpenChange}
                  placement="top-center"
                  backdrop="blur"
                >
                  <ModalContent>
                    {(onClose) => (
                      <>
                        <ModalHeader className="flex flex-col gap-1 font-MorabbaMeduim text-mainColor">
                          {t("confirmReview")}
                        </ModalHeader>
                        <ModalBody>
                          <Input
                            className="col-span-1"
                            radius="sm"
                            variant="bordered"
                            size="lg"
                            ref={lastNameRef}
                            placeholder={t("name")}
                            labelPlacement="outside"
                          />
                          <Input
                            className="col-span-1"
                            radius="sm"
                            variant="bordered"
                            size="lg"
                            ref={EmailRef}
                            placeholder={t("Email")}
                            labelPlacement="outside"
                            error={!!emailError} // Show error styles if there's an error
                            helperText={emailError} // Show the error message
                          />
                          <Textarea
                            variant="bordered"
                            label={t("fmmessage")}
                            value={reviewMessage}
                            onChange={(e) => setReviewMessage(e.target.value)} // Update state on change
                          />
                          <div className="flex justify-between items-center ">
                            <span className="mb-2"> {t("rating")}:</span>
                            {/* Replace Slider with the StarRating component */}
                            <StarRating
                              rating={rating}
                              onRatingChange={setRating}
                            />
                          </div>
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            color="danger"
                            variant="flat"
                            onPress={onClose}
                          >
                            {t("cancel")}
                          </Button>
                          <Button
                            color="primary"
                            className="text-black"
                            onClick={handleSubmit}
                          >
                            {t("confirm")}
                          </Button>
                        </ModalFooter>
                      </>
                    )}
                  </ModalContent>
                </Modal>
              </Card>
            </div>
          </div>
        </div>
      </BaseLayout>
    </>
  );
}
